import { render, staticRenderFns } from "./pcFooter.vue?vue&type=template&id=1c50e284&"
import script from "./pcFooter.vue?vue&type=script&lang=js&"
export * from "./pcFooter.vue?vue&type=script&lang=js&"
import style0 from "./pcFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports